import axiosInstance from "../../utils/axios/axios";
import baseUrl from "../../utils/baseUrl/baseUrl";
import {
  successToast,
  errorToast,
} from "../../utils/notificationAlert/notificationAlert";
import store from "../../redux/store";
import {
  hideLoader,
  showLoader,
} from "../../redux/features/settings/setttingsSlice";
import {
  getToken,
  sessionDestroy,
} from "../../utils/sessionHelper/sessionHelper";
import { setPopupNotification } from "../../redux/features/webSettings/webSetttingsSlice";

const AxiosHeader = {
  withCredentials: true,
  headers: { token: getToken(), "Content-Type": "multipart/form-data" },
};

export let addPopupNotificationRequest = async (data) => {
  try {
    store.dispatch(showLoader());
    let URL = baseUrl + "/add-popup-notification";
    let res = await axiosInstance.post(URL, data, AxiosHeader);
    store.dispatch(hideLoader());
    console.log(res.data);
    if (res.data?.status === "success" && res.data?.fileResult?.length > 0) {
      successToast("Added Pop Up Notification success");
      return true;
    } else {
      errorToast("Request fail. Please try again");
      return false;
    }
  } catch (e) {
    store.dispatch(hideLoader());
    if (e?.response?.status == 401) {
      sessionDestroy();
    }
    errorToast("Something Went Wrong");
    return false;
  }
};

export let getAllPopupNotificationRequest = async () => {
  try {
    store.dispatch(showLoader());
    let URL = baseUrl + "/get-popup-notifications/1/100/0";
    let res = await axiosInstance.get(URL);
    store.dispatch(hideLoader());
    if (
      res.data?.status === "success" &&
      res.data?.data?.[0]?.total?.[0]?.count > 0
    ) {
      store.dispatch(setPopupNotification(res.data?.data?.[0]?.rows));
      return true;
    } else {
      errorToast("Request fail. Please try again");
      return false;
    }
  } catch (e) {
    store.dispatch(hideLoader());
    if (e?.response?.status == 401) {
      sessionDestroy();
    }
    errorToast("Something Went Wrong");
    return false;
  }
};

export let deletePopupNotificationRequest = async (id) => {
  try {
    store.dispatch(showLoader());
    let URL = baseUrl + `/delete-popup-notification/${id}`;
    let res = await axiosInstance.post(URL);
    store.dispatch(hideLoader());
    if (res.data?.status === "success" && res.data?.data?.deletedCount == 1) {
      successToast("Deleted Pop Up Notification success");
      return true;
    } else {
      errorToast("Request fail. Please try again");
      return false;
    }
  } catch (e) {
    store.dispatch(hideLoader());
    if (e?.response?.status == 401) {
      sessionDestroy();
    }
    errorToast("Something Went Wrong");
    return false;
  }
};
